import { render } from "./list-icon.svg?vue&type=template&id=f9fe2ca0"
import script from "./list-icon.svg?vue&type=script&lang=js"
export * from "./list-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4040/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__